/* @flow */

import React from "react";
import { useData } from "crustate/react";
import { useClient, StoreInfoContext } from "entrypoint/shared";

import { QuoteData, CmsPageData } from "state/data";
import { Checkout } from "@crossroads/shop-views";
import CmsPage from "pages/CmsPage";
import { useAnalytics } from "context/analytics";
import useFormat from "helpers/hooks/use-format";
import { useTranslate } from "@awardit/react-use-translate";
import { altapay } from "config";

const Overview = (): React$Node => {
  const quote = useData(QuoteData);
  const cmsData = useData(CmsPageData);
  const { formatPrice } = useFormat();
  const analytics = useAnalytics();
  const t = useTranslate();

  const agreementPage = cmsData.state === "LOADED" ? <CmsPage cmsPage={cmsData.data} showBreadcrumbs={false} /> : null;

  if (!quote.data) {
    return null;
  }

  return (
    <Checkout
      analytics={{ context: analytics }}
      quote={quote}
      formatPrice={formatPrice}
      useClient={useClient}
      StoreInfoContext={StoreInfoContext}
      scriptURL={altapay.src}
      agreement={agreementPage}
      extraOrderInfo={t("CHECKOUT.EXTRA_INFO")}
    />
  );
};

export default Overview;
